import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/eng.png'
import _imports_1 from '@/assets/img/arrow.svg'
import _imports_2 from '@/assets/img/thai.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-779674d2")

_pushScopeId("data-v-779674d2")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "footMenu" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "footMenu" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "bi bi-lock-fill" }, null, -1)
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "footMenu" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "footMenu" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = {
  href: "https://www.facebook.com/moneyspace.net",
  target: "_blank"
}
const _hoisted_17 = { class: "wrapper" }
const _hoisted_18 = { class: "in" }
const _hoisted_19 = { class: "in" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("footer", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("span", _hoisted_5, [
              _createVNode(_component_router_link, {
                style: {"color":"inherit !important"},
                to: { path: '/product' }
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.t("footer.productArea.title")), 1)
                ]),
                _: 1
              })
            ]),
            _createVNode("ul", null, [
              _createVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: { path: '/links' },
                  innerHTML: _ctx.$t('footer.productArea.products[0]')
                }, null, 8, ["innerHTML"])
              ]),
              _createVNode("li", null, [
                _createVNode(_component_router_link, {
                  to: { path: '/' },
                  innerHTML: _ctx.$t('footer.productArea.products[1]')
                }, null, 8, ["innerHTML"])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("span", _hoisted_8, _toDisplayString(_ctx.t("footer.featureArea.title")), 1),
            _createVNode("ul", null, [
              _createVNode("li", null, [
                _createVNode(_component_router_link, { to: { path: '/dashboard' } }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("footer.featureArea.features[0]")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createVNode("li", null, [
                _createVNode(_component_router_link, { to: { path: '/payment-demo' } }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("footer.featureArea.features[4]")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createVNode("li", null, [
                _createVNode("a", {
                  href: _ctx.documentUrl,
                  target: "_blank",
                  rel: "noopener"
                }, [
                  _createTextVNode(_toDisplayString(_ctx.t("footer.featureArea.features[6]")) + " ", 1),
                  _hoisted_9
                ], 8, ["href"])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode("span", _hoisted_12, _toDisplayString(_ctx.t("footer.moneySpaceArea.title")), 1),
            _createVNode("ul", null, [
              _createVNode("li", null, [
                _createVNode(_component_router_link, { to: { path: '/about-us' } }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("footer.moneySpaceArea.moneySpaces[0]")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createVNode("li", null, [
                _createVNode(_component_router_link, { to: { path: '/contact-us' } }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("footer.moneySpaceArea.moneySpaces[2]")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createVNode("li", null, [
                _createVNode(_component_router_link, { to: { path: '/privacy' } }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("footer.moneySpaceArea.moneySpaces[4]")), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _createVNode("span", _hoisted_15, _toDisplayString(_ctx.t("footer.faqArea.title")), 1),
            _createVNode("ul", null, [
              _createVNode("li", null, [
                _createVNode(_component_router_link, { to: { path: '/businesses' } }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("footer.faqArea.faqs[0]")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createVNode("li", null, [
                _createVNode("a", {
                  href: _ctx.locale === 'en' ? '/static/refund_payments_en.pdf' : '/static/refund_payments_th.pdf',
                  target: "_blank"
                }, _toDisplayString(_ctx.t("footer.faqArea.faqs[1]")), 9, ["href"])
              ]),
              _createVNode("li", null, [
                _createVNode("a", _hoisted_16, _toDisplayString(_ctx.t("footer.faqArea.faqs[2]")), 1)
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_17, [
        _createVNode("div", {
          class: "langBlock invert",
          onMouseleave: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.leavemouse && _ctx.leavemouse(...args)))
        }, [
          _createVNode("div", {
            class: _ctx.arrowClicked === true ? 'head active' : 'head'
          }, [
            _createVNode("div", _hoisted_18, [
              _createVNode("img", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLocale('en'))),
                src: _imports_0,
                alt: "eng",
                class: "lang"
              }),
              _createVNode("img", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showSecondLangBlock())),
                src: _imports_1,
                alt: "arrow",
                class: "arr"
              })
            ])
          ], 2),
          _createVNode("div", {
            class: ["list", { showSecondLangBlockCSS: _ctx.arrowClicked }]
          }, [
            _createVNode("div", _hoisted_19, [
              _createVNode("img", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setLocale('th'))),
                src: _imports_2,
                alt: "thai",
                class: "lang"
              })
            ])
          ], 2)
        ], 32)
      ])
    ])
  ]))
})